module.exports = __webpack_public_path__ + "img/header-contact.c390572a.jpg";